<script>
export default {
  data() {
    return {
      series: [],
      chartOptions: {},
    };
  },
  methods: {
    setData(data){
      let allocations = [];
      let utilizations = [];
      let remainings = [];
      let cat = [];
      let categories = []
      data.map(item => {
        allocations.push(item.allocation);
        utilizations.push(item.utilization);
        remainings.push(item.remaining);
        let myArray = item.account.accountName.split(" ");
        let myString = '';
        myArray.map(word => {
          if(word.charAt(0) == word.charAt(0).toUpperCase()){
            myString += word.charAt(0);
          }
        })
        cat.push(myString);
        categories.push(item.account.accountName);
      })
      this.series = [
        {
          name: "Allocation",
          data: allocations,
        },
        {
          name: "Utilization",
          data: utilizations,
        },
        {
          name: "Remaining",
          data: remainings,
        },
      ];
      this.chartOptions = {
        chart: {
          stacked: true,
          toolbar: {
            show: false,
          },
          zoom: {
            enabled: true,
          },
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "20%",
          },
        },
        dataLabels: {
          enabled: false,
        },
        xaxis: {
          categories: categories,
          tooltip: {
            enabled: false,
          }
        },
        colors: ["#556ee6", "#f1b44c", "#34c38f"],
        legend: {
          position: "top",
        },
        fill: {
          opacity: 1,
        },
      }
    }
  }
};
</script>
<template>
    <div class="card">
      <div class="card-body">
        <div class="d-sm-flex flex-wrap">
          <h4 class="card-title mb-4">Line Budget Items</h4>
          <!-- <div class="ms-auto">
            <ul class="nav nav-pills">
              <li class="nav-item">
                <a class="nav-link" href="javascript: void(0);">Week</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="javascript: void(0);">Month</a>
              </li>
              <li class="nav-item">
                <a class="nav-link active" href="javascript: void(0);">Year</a>
              </li>
            </ul>
          </div> -->
        </div>

        <apexchart
          class="apex-charts"
          type="bar"
          dir="ltr"
          height="360"
          :series="series"
          :options="chartOptions"
        ></apexchart>
      </div>
    </div>
</template>